import React from 'react';

import MessageBox from './MessageBox';

const VerifyEmailFail = () => {
  return (
    <MessageBox
      header="Whoops!"
      message="Your email verification was unsuccessful."
      secondaryMessage="First, check that you are clicking the most recent verification link. Still stuck? Contact our support team at support@bracken.cloud."
    />
  )
}

export default VerifyEmailFail;
